import ReactDOM from 'react-dom'
import { init as initApm } from '@elastic/apm-rum'

import {
  API_GATEWAY_BASE_URL,
  ELASTIC_SERVICE_VERSION,
  SOCKET_URL,
} from '@pepper/utils/src/api/config'
import filterApmErrors from '@pepper/utils/src/function/filterApmErrors'
import './App.less'
import '@pepper/ui/src/styles/index.css'
import '@pepper/ui/src/styles/grid.css'
// import '@pepper/ui-core/dist/style.css'
// import '@pepper/ui/dist/style.css'

import App from './App'
import { registerModals } from './modals'

if (import.meta.env.REACT_APP_APM_ENABLED === 'TRUE') {
  const apm = initApm({
    serviceName: 'fe-business-platform',
    serverUrl:
      'https://3ac94a15e62a486f867ef7755d2bdbc6.apm.ap-south-1.aws.elastic-cloud.com',
    serviceVersion: ELASTIC_SERVICE_VERSION,
    environment: import.meta.env.REACT_APP_APM_ENVIRONMENT ?? 'dev',
    distributedTracingOrigins: [API_GATEWAY_BASE_URL, SOCKET_URL],
  })

  apm.addFilter(filterApmErrors)
}

// Register the modals
registerModals()

ReactDOM.render(<App />, document.getElementById('root'))
